import { KeeperFormData } from "src/components/KeeperDrawer/KeeperDrawer";

const KEEPER_DATA_START = "---KEEPER_DATA---";
const KEEPER_DATA_END = "---END_KEEPER_DATA---";
const KEEPER_BLOCK_REGEX = /\n*---KEEPER_DATA---[\s\S]*?---END_KEEPER_DATA---\s*/;

export const extractKeeperData = (
  notes: string
): { cleanNotes: string; keeperData: KeeperFormData | null } => {
  if (!notes || typeof notes !== "string") {
    return { cleanNotes: "", keeperData: null };
  }

  const match = notes.match(KEEPER_BLOCK_REGEX);
  if (!match) {
    return { cleanNotes: notes.trimEnd(), keeperData: null };
  }

  const cleanNotes = notes.replace(KEEPER_BLOCK_REGEX, "").trimEnd();
  const blockContent = match[0]
    .replace(KEEPER_DATA_START, "")
    .replace(KEEPER_DATA_END, "")
    .trim();

  try {
    const parsed = JSON.parse(blockContent) as KeeperFormData;
    return { cleanNotes, keeperData: parsed };
  } catch {
    return { cleanNotes, keeperData: null };
  }
};

export const injectKeeperData = (cleanNotes: string, keeperData: KeeperFormData | null): string => {
  const base = (cleanNotes || "").trimEnd();
  if (!keeperData) {
    return base;
  }

  const block = `\n\n${KEEPER_DATA_START}\n${JSON.stringify(keeperData)}\n${KEEPER_DATA_END}`;
  return base ? `${base}${block}` : block.trim();
};

export const mapLeagueInfoToCalculatorSettings = (info: any, notes: string) => {
  const apiSettings = info?.settings || {};

  let leagueType = "dynasty";
  if (info?.league_type === "redraft" || info?.league_type === "Redraft") leagueType = "redraft";
  else if (info?.league_type === "keeper" || info?.league_type === "Keeper") leagueType = "keeper";

  let teamFormat = "standard";
  if (apiSettings.superflex === 1 || apiSettings.superflex === true) teamFormat = "sf";
  else if (apiSettings["2QB"] === 1 || apiSettings["2QB"] === true) teamFormat = "2qb";

  let teamType = "ppr";
  if (info?.league_format === "half_ppr" || info?.league_format === ".5 PPR") {
    teamType = "half_ppr";
  } else if (
    info?.league_format === "nonppr" ||
    info?.league_format === "non-ppr" ||
    info?.league_format === "Non-PPR" ||
    info?.league_format === "NON-PPR"
  ) {
    teamType = "nonppr";
  }

  return {
    league_type: leagueType,
    team_format: teamFormat,
    team_type: teamType,
    team_size: info?.league_size?.toString() || "12",
    te_premium: apiSettings.TE_Premium === 1 || apiSettings.TE_Premium === true ? 1 : 0,
    rb_premium: apiSettings.RB_PPC === 1 || apiSettings.RB_PPC === true ? 1 : 0,
    notes,
  };
};
